export const loginPageContent = {
	width: '510px',
};
